import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { CompassAPIProductsService } from "../api-compass/compass-api-products.service";
import { Product } from "../models/product.interface";

@Injectable({ providedIn: 'root' })
export class ProductResolver implements Resolve<Product> {
	constructor(private _compassAPIProductsService: CompassAPIProductsService) {}

	resolve(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Observable<Product> {
		//console.log('ProductResolver:', route);
		return this._compassAPIProductsService.getProductByRegDestProdSlug(route.params.regionSlug, route.params.destinationSlug, route.params.slug);
	}
}